export const patientInfo: any = {
  accessRights: [
    {
      accessCode: '062439',
      daysRemaining: 2,
      durationInDays: 90,
      endDate: '2022-11-03T20:00:00-04:00',
      id: 'b3c966b0-910b-4ab5-a4ac-260dd93a3c83',
      program: 'reSET',
      startDate: '2022-08-05T21:00:00-04:00',
      status: 'started',
      inAppCm: false,
      isSample: false,
      useOfBup: false,
      totalDaysActive: 88,
      timezone: 'America/New_York',
    },
    {
      accessCode: '391204',
      daysRemaining: 0,
      durationInDays: 90,
      endDate: '2022-10-18T20:00:00-04:00',
      id: 'b11787f5-c3be-44f7-9ac3-99b0786b900a',
      program: 'reSET',
      startDate: '2022-07-20T20:00:00-04:00',
      status: 'expired',
      inAppCm: false,
      isSample: false,
      useOfBup: true,
      totalDaysActive: 90,
      timezone: 'America/New_York',
    },
  ],
  dateOfBirth: '2000-01-01',
  emailAddress: 'hylia_api_patient1@peartx.com',
  firstName: 'Hylia-API',
  id: 'd9fa72c4-1531-4475-99ca-3724bb6dace5',
  lastName: 'Test-Patient1',
};
